import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { completeEventbriteSignIn } from "../eventbrite/eventbriteService";
import { isEventbriteEnabled } from "../eventbrite/eventbriteFeature";
import { useAuth } from "./AuthContext";

const AuthCallback = () => {
  const navigate = useNavigate();
  const { isLoading, session, signInWithEventbrite } = useAuth();
  const [isEventbriteReturn] = useState(() => new URLSearchParams(window.location.search).get("provider") === "eventbrite");
  const [error, setError] = useState("");
  const [attempt, setAttempt] = useState(0);
  const completionRef = useRef(null);

  useEffect(() => {
    if (isLoading) return undefined;
    if (!isEventbriteReturn || !isEventbriteEnabled()) {
      navigate("/", { replace: true });
      return undefined;
    }
    if (!session) {
      setError("Eventbrite sign-in was cancelled or could not be completed. Please try again.");
      return undefined;
    }
    let active = true;
    setError("");
    // Reuse the in-flight request across effect remounts and auth session updates.
    if (!completionRef.current) completionRef.current = completeEventbriteSignIn(session);
    completionRef.current.then(() => {
      if (active) navigate("/", { replace: true });
    }).catch((failure) => {
      if (active) setError(failure.message || "Could not finish connecting Eventbrite.");
    });
    return () => { active = false; };
  }, [attempt, isEventbriteReturn, isLoading, navigate, session]);

  return (
    <main className="auth-shell">
      <section className="auth-card" aria-live="polite">
        <p className="auth-eyebrow">BadgeFlow</p>
        <h1>Finishing sign in…</h1>
        {error ? <>
          <div className="auth-alert" role="alert">{error}</div>
          {session?.provider_token && <button className="button" type="button" onClick={() => {
            completionRef.current = null;
            setAttempt((value) => value + 1);
          }}>Retry connection</button>}
          <button className="auth-google-button" type="button" onClick={() => {
            signInWithEventbrite().catch((failure) => setError(failure.message || "Could not start Eventbrite sign-in."));
          }}>Sign in with Eventbrite again</button>
        </> : <p>{isEventbriteReturn ? "Connecting your Eventbrite events…" : "We are securely confirming your email link."}</p>}
      </section>
    </main>
  );
};

export default AuthCallback;
